var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('AppAlert'),(this.$route.path != '/exemplos' && this.$route.path != '/mercadopago')?_c('AppBar'):_vm._e(),(!_vm.loading)?_c('AppContent'):_vm._e(),(_vm.loading)?_c('AppLoading'):_vm._e(),_c('AppFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }